import { AppLayout } from '../components/AppLayout';
import { UserRoute } from '../components/ProtectedRoute';

// Use UserRoute to allow all authenticated users (admin, host, guest)
// Fine-grained session access is handled by the session endpoints and components
export default [UserRoute, AppLayout];
